export type MessageLang = 'en' | 'mr' | 'hi';

export const MESSAGE_LANGS: { value: MessageLang; label: string }[] = [
  { value: 'en', label: 'English' },
  { value: 'mr', label: 'मराठी' },
  { value: 'hi', label: 'हिन्दी' },
];

interface Facts {
  agency: string;
  broker: string;
  client: string;
  property: string;
  /** The page the message points at. */
  link: string;
}

/** A link that opens the page in the language of the message. */
export function withLang(link: string, lang: MessageLang): string {
  return `${link}${link.includes('?') ? '&' : '?'}lang=${lang}`;
}

const TEXT: Record<
  MessageLang,
  {
    proof: (f: Facts & { date: string }) => string;
    askOwner: (f: Facts) => string;
    askClient: (f: Facts) => string;
  }
> = {
  en: {
    proof: (f) =>
      `${f.agency}: ${f.client} was introduced to ${f.property} by ${f.broker} on ${f.date}. See the record here: ${f.link}`,
    askOwner: (f) =>
      `${f.agency}: ${f.broker} brought ${f.client} to see ${f.property}. Please tap to say you know about this: ${f.link}`,
    askClient: (f) =>
      `${f.agency}: ${f.broker} arranged your visit to ${f.property}. Please tap to say you know about this: ${f.link}`,
  },
  mr: {
    proof: (f) =>
      `${f.agency}: ${f.client} यांची ${f.property} शी ओळख ${f.broker} यांनी ${f.date} रोजी करून दिली. नोंद इथे पहा: ${f.link}`,
    askOwner: (f) =>
      `${f.agency}: ${f.broker} यांनी ${f.client} यांना ${f.property} पाहण्यासाठी आणले. तुम्हाला याची माहिती आहे हे सांगण्यासाठी टॅप करा: ${f.link}`,
    askClient: (f) =>
      `${f.agency}: ${f.broker} यांनी ${f.property} ची तुमची भेट ठरवली. तुम्हाला याची माहिती आहे हे सांगण्यासाठी टॅप करा: ${f.link}`,
  },
  hi: {
    proof: (f) =>
      `${f.agency}: ${f.client} का ${f.property} से परिचय ${f.broker} ने ${f.date} को कराया। रिकॉर्ड यहाँ देखें: ${f.link}`,
    askOwner: (f) =>
      `${f.agency}: ${f.broker} ${f.client} को ${f.property} दिखाने लाए। आपको इसकी जानकारी है, यह बताने के लिए टैप करें: ${f.link}`,
    askClient: (f) =>
      `${f.agency}: ${f.broker} ने ${f.property} की आपकी विज़िट तय की। आपको इसकी जानकारी है, यह बताने के लिए टैप करें: ${f.link}`,
  },
};

export const proofMessage = (lang: MessageLang, facts: Facts & { date: string }): string =>
  TEXT[lang].proof({ ...facts, link: withLang(facts.link, lang) });

export const askOwnerMessage = (lang: MessageLang, facts: Facts): string =>
  TEXT[lang].askOwner({ ...facts, link: withLang(facts.link, lang) });

export const askClientMessage = (lang: MessageLang, facts: Facts): string =>
  TEXT[lang].askClient({ ...facts, link: withLang(facts.link, lang) });
